export function getUserInitials(email: string) {
    return email
        .split('@')[0]
        .split('.')
        .map((word) => word[0])
        .join('')
        .toUpperCase();
}
